import { render, staticRenderFns } from "./ItemExcel.vue?vue&type=template&id=87281b42&scoped=true&"
import script from "./ItemExcel.vue?vue&type=script&lang=ts&"
export * from "./ItemExcel.vue?vue&type=script&lang=ts&"
import style0 from "./ItemExcel.vue?vue&type=style&index=0&id=87281b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87281b42",
  null
  
)

export default component.exports